<template>
    <div>
        Open App
    </div>
</template>

<script>
    import AppService from "../../services/AppService";
    import AppManager from "../../managers/AppManager";

    export default {
        name: 'OpenApp',
        data () {
            return {
                model: webase.model,
                service: new AppService()
            }
        },
        mounted() {
            console.log('OpenApp')
            console.log(this.$route.params.id)
            if (this.$route.params.id) {
                let appId = this.$route.params.id

                this.service.initApp(appId).then((response) => {
                    this.model.app = response
                    let manager = new AppManager(this.model.app)

                    if(this.model.app.default_view_id && manager.getView(this.model.app.default_view_id)) {
                        this.$router.push({ name: 'view-renderer', params: {id: this.model.app.default_view_id}})
                        return
                    }

                    let table = response.tables[0]

                    if(!table) {
                        this.$router.push({name: 'app-editor', params: {id: this.model.app.id}})
                        return
                    }

                    let view = table.views[0]
                    this.$router.push({ name: 'view-renderer', params: {id: view.id}})
                }).catch((message) => {
                    console.log('error loading app')
                    console.log(message)
                })
            }
        }
    }
</script>

<style>

</style>
